import { Trans } from '@lingui/react'
import type { FC } from 'react'

import { EXPERIMENT_VARIATION } from 'shared/experiments/consts'
import type { Experiment } from 'types/shopConfig'

type DeliveryDatesForOtcProps = {
  experiment: Experiment
}

const DeliveryDatesForOtc: FC<DeliveryDatesForOtcProps> = ({ experiment }) => {
  switch (experiment.variant) {
    case EXPERIMENT_VARIATION.DEFAULT:
      return <Trans id="general.label.product.available" />
    case EXPERIMENT_VARIATION.V1:
      return <Trans id="general.label.product.availableDays" />
    case EXPERIMENT_VARIATION.V2:
      return <Trans id="general.label.product.availableDaysV2" />
    default:
      return <Trans id="general.label.product.available" />
  }
}

export default DeliveryDatesForOtc
